import { render, staticRenderFns } from "./FlagFormatter.vue?vue&type=template&id=9e025c26&scoped=true&"
import script from "./FlagFormatter.vue?vue&type=script&lang=js&"
export * from "./FlagFormatter.vue?vue&type=script&lang=js&"
import style0 from "./FlagFormatter.vue?vue&type=style&index=0&id=9e025c26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e025c26",
  null
  
)

export default component.exports